module.exports = __webpack_public_path__ + "media/images/image-placeholder-48926a3270fff955c8c228b126ad3dd8.jpg";